/* This file houses shared viewable components for the Coach */
import styles from "./shared.module.css"
import React from "react"
import cx from "classnames"
import * as typo from "story/components/typography"
import UpArrow from "../../../images/Up-Arrow.svg?react"

export const Directions = ({title, inlineStyles, customStyles, children}) => (
  <div className={cx(styles["directions"], customStyles)} style={inlineStyles}>
    {title && <div className={styles["title"]}>{title}</div>}
    <div className={styles["copy"]}>{children}</div>
  </div>
)

export const FloatingArrows = ({customStyles, customTextStyles, inlineTextStyles, children}) => (
  <div className={cx(customStyles, styles["animated-directions"])}>
    <span>
      <UpArrow />
    </span>
    <div style={inlineTextStyles} className={cx(customTextStyles, styles["with-arrows"])}>
      {children}
    </div>
    <span>
      <UpArrow />
    </span>
  </div>
)

export const StartBanner = () => (
  <div className={styles["start-banner"]}>
      <div className={styles["line-1"]}>
        <div className={styles["line-1-text"]}>Activity</div>
      </div>
      <div className={styles["line-2"]}>
        <div className={styles["line-2-text"]}>Start!</div>
      </div>
  </div>
)

export const Centered = ({children}) => <div className={styles["centered"]}>{children}</div>

export const Section = ({className, children}) => <div className={cx(className, styles["section"])}>{children}</div>

export const Error = ({children}) => <div className={styles["error"]}>{children}</div>

export const Line = () => <div className={styles["line"]}></div>

export const Results = ({customStyles, children}) => <div className={cx(customStyles, styles["results"])}>{children}</div>

export const Result = ({result, label, className, customHeaderStyles}) => (
  <div className={cx(className, styles["result"])}>
    <typo.Label>{label}</typo.Label>
    <typo.Header customStyles={customHeaderStyles} className="medium">
      {result}
    </typo.Header>
  </div>
)

export const Center = ({children}) => <div className={styles["center"]}>{children}</div>
